<template>
    <div>
    <Modal
        class-name="vertical-center-modal"
        :value="showSetModel  && (DataType==6 || DataType==12)"
        :title="$t('edit')"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'600px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80" >
             <FormItem :label="$t('BasicProduct.funcBox.titleName.time')" prop="time" style="width: 500px" v-if="DataType==12">
                <Select :placeholder="$t('selectPlaceholder')"  class="input-div" v-model="formData.time">
                    <Option v-for="item in timeList1" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                </Select>
            </FormItem>

             <FormItem :label="$t('BasicProduct.funcBox.titleName.time')" prop="time" style="width: 500px" v-else>
                <Select :placeholder="$t('selectPlaceholder')"  class="input-div" v-model="formData.time">
                    <Option v-for="item in timeList2" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                </Select>
            </FormItem>

            <FormItem :label="$t('BasicProduct.funcBox.titleName.timeFormate')" prop="formate" style="width: 500px">
                <Select :placeholder="$t('selectPlaceholder')"  class="input-div" v-model="formData.formate">
                    <Option v-for="item in timeFormateList" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                </Select>
            </FormItem>


             <FormItem :label="$t('BasicProduct.funcBox.titleName.Max')" prop="max" style="width: 500px" >
                 <Input type="text"  v-model.trim="formData.max"  :placeholder="$t(`inputPlaceholder`)"></Input>
            </FormItem>

             <FormItem :label="$t('BasicProduct.funcBox.titleName.Min')" prop="min" style="width: 500px" >
               <Input type="text"  v-model.trim="formData.min"  :placeholder="$t(`inputPlaceholder`)"></Input>
            </FormItem>



        
             <FormItem v-if="isGener || readOnly">
                <Button type="primary" @click="cancel">{{$t("cancel")}}</Button>
            </FormItem>

            <FormItem v-else>
                <Button type="primary"  :disabled="type==3" @click="handleSubmit('formData')">{{$t('save')}}</Button>
                <Button @click="cancel" style="margin-left: 8px">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showSetModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import { mapState } from 'vuex'

    export default {
        props: {
            showSetModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,
            DataType:String,
            // languageKey:Object,
            // initdata:Object,
            isGener:{
                type:Boolean,
                default:false
            },
            readOnly:{
                type:Boolean,
                default:false
            }
        },
        name: "ModelTimeType",
        data() {
            return {   
                disabled: false,//禁用确定按钮
                formData: {
                   time:'',
                //    label:'',
                   max:'',
                   min:'',
                   formate:''
                //    code:''
                },
                // timeFormateList:[
                //     {id: 'YYYY-MM-DD',val:"YYYY-MM-DD"},
                //     {id: 'YYYY-MM-DD HH-MM-SS',val:"YYYY-MM-DD HH-MM-SS"},
                //     {id: 'HH-MM-SS',val:"HH-MM-SS"},
                //     {id: 'HH-MM',val:"HH-MM"},
                //     {id: 'MM-SS',val:"MM-SS"},
                //     {id: 'MM-SS-MS',val:"MM-SS-MS"},
                //     {id: 'SS-MS',val:"SS-MS"},
                // ]
            }
        },
        computed:{
            ...mapState(['local','selectId','timeFormateList']),
            timeList1(){
                return [
                    {id: '0x01',val:this.$t('selectList.timeUnit.msceond')},
                    {id: '0x02',val:this.$t('selectList.timeUnit.second')},
                    {id: '0x03',val:this.$t('selectList.timeUnit.minute')},
                    {id: '0x04',val:this.$t('selectList.timeUnit.hour')},
                ]
            },
            timeList2(){
                return [
                    {id: '1',val:this.$t('selectList.timeUnit.msceond')},
                    {id: '2',val:this.$t('selectList.timeUnit.second')},
                    {id: '3',val:this.$t('selectList.timeUnit.minute')},
                    {id: '4',val:this.$t('selectList.timeUnit.hour')},
                ]
            },
             ruleCustom(){
                 return {//验证
                    time: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    formate: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    max: [
                        {required: false, message: this.$t('required'),trigger: 'blur' },
                    ],
                    min: [
                        {required: false, message: this.$t('required'),trigger: 'blur' },
                    ]
                }
             } 

        },
        methods: {
            handleSubmit (name) {
                if(this.isGener){
                    return
                }
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        // console.log('this.formDatathis.formData',this.formData)

                       let timelist = [...this.timeList1,...this.timeList2]
                    //    timelist.map(item=>{
                    //         if(item.id==this.formData.time){
                    //           this.formData.label = item.val
                    //         }
                    //    })
                       
                       this.fn({...this.formData},this.DataType)
                       setTimeout(()=>{
                           this.resetForm()
                       },0)
                    } else {
                        this.$Message.error('Fail!');
                    }
                })
            },
          
            openOrClose(value) {
                if(value === true) {
                    if(this.type==2){
                       this.formData=  {...this.editFormData.IndentyName}
                    }
                    // console.log('editFormData',this.editFormData)
                }
            },
            cancel() {//对话框关闭
                this.$emit('update:showSetModel',false);
                this.resetForm()
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>

<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
.delButton {
    /deep/ .ivu-form-item-content {
    margin-left: 20px !important;
}
}
</style>

